import { ThemeNames } from '@benzinga/themetron';
import { ChartOptions, DeepPartial, ColorType } from 'lightweight-charts';
import { mergeDeepLeft } from 'ramda';
import { ChartData } from '../entities';

import { getDynamicPriceStateAtPeriod } from './getDynamicPriceStateAtPeriod';

import { deprecated } from '@benzinga/themetron';
const { ChartPeriod, getChartColor, getThemeColors } = deprecated;

export const CHART_CONSTANTS = {
  fontFamily: 'proxima nova',
  locale: 'en-US',
  priceFormat: {
    minMove: 0.05,
  },
};

const baseConfig: DeepPartial<ChartOptions> = {
  crosshair: {
    horzLine: {
      labelVisible: false,
    },
  },

  grid: {
    horzLines: {
      color: 'rgba(73, 83, 96, 1)',
      visible: false,
    },

    vertLines: {
      visible: false,
    },
  },

  layout: {
    background: {
      color: 'transparent',
      type: ColorType.Solid,
    },
    fontFamily: CHART_CONSTANTS.fontFamily,
    textColor: '#ffffff',
  },

  leftPriceScale: {
    alignLabels: false,
    autoScale: true,
    mode: 1,
  },

  localization: {
    locale: CHART_CONSTANTS.locale,
  },

  timeScale: {
    borderColor: '#4d5866',
    borderVisible: true,
    secondsVisible: false,
    timeVisible: true,
  },
};

const getUpdatedSeriesConfig = (chartData: ChartData[]) => {
  const isIncreasing = getDynamicPriceStateAtPeriod(chartData);
  const { bottomColor, lineColor, topColor } = isIncreasing
    ? getChartColor(ChartPeriod.increase)
    : getChartColor(ChartPeriod.decrease);

  return {
    bottomColor,
    lastValueVisible: false,
    lineColor,
    priceLineVisible: false,
    topColor,
  };
};

const getUpdatedThemeConfig = (config: DeepPartial<ChartOptions>, theme: ThemeNames): DeepPartial<ChartOptions> => {
  const { accentColor2, mainColor, tooltipBackground } = getThemeColors(theme);
  const themeFieldsToUpdate: DeepPartial<ChartOptions> = {
    crosshair: {
      vertLine: {
        labelBackgroundColor: tooltipBackground,
      },
    },

    grid: {
      horzLines: {
        color: accentColor2,
        visible: true,
      },
    },
    layout: {
      textColor: mainColor,
    },
  };

  return mergeDeepLeft(themeFieldsToUpdate, config) as DeepPartial<ChartOptions>;
};

export { baseConfig, getUpdatedThemeConfig, getUpdatedSeriesConfig };
